module.exports = __webpack_public_path__ + "Typedepot---CentraleSansXBold.daf8fcba499b0911cde5.woff";


//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/assets/fonts/Typedepot---CentraleSansXBold.woff
// module id = ../../../../../src/assets/fonts/Typedepot---CentraleSansXBold.woff
// module chunks = styles